<div class="dialog-options" [ngStyle]="{
  'left.px': data['targetX'],
  'top.px': data['targetY']
}">
    <div class="dialog-link" (click)="onSelect('Created')">Created Date</div>
    <div class="dialog-link" (click)="onSelect('Updated')">Updated Date</div>
    <div class="dialog-link" (click)="onSelect('Clear')">Clear Filter</div>

</div>